export default __webpack_public_path__ + "static/joko-app-screenshot-home-2-en@2x-6fab9a1f9ff19e6819a2468e56d29841.png";